const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'Natureza é obrigatório'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === 'TOTVS') {
    return validateCamposErpTotvs(camposIntegracao);
  }
  return [true, null];
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === 'TOTVS') {
    return {
      natureza: null,
    };
  }
  return {};
};
